import { RecipientsResponseModel } from "../pages/shared/models/api/recipinets-response.moel";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function createRecipient(formData: FormData) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    authorizationHeader.headers["Content-Type"] = "multipart/form-data";

    return axiosInstance
      .post(`${API_URL}/recipients/create`, formData, authorizationHeader)
      .then((response) => response?.data as RecipientUpdateMeta);
  } catch (error) {
    console.error(error);

    return {
      acknowledged: false,
      matchedCount: 0,
      modifiedCount: 0,
      upsertedCount: 0,
      upsertedId: 0,
    };
  }
}

async function editRecipient(
  recipientId: number,
  formData: FormData | { [key: string]: any },
) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    authorizationHeader.headers["Content-Type"] = "multipart/form-data";

    if (formData instanceof FormData) {
      formData.delete("recipientId");
    } else {
      delete formData.recipientId;
    }

    return axiosInstance
      .put(
        `${API_URL}/recipients/${recipientId}`,
        formData,
        authorizationHeader,
      )
      .then((response) => response?.data as RecipientUpdateMeta);
  } catch (error) {
    console.error(error);

    return {
      acknowledged: false,
      matchedCount: 0,
      modifiedCount: 0,
      upsertedCount: 0,
      upsertedId: 0,
    };
  }
}

async function changeDefaultRecipient(recipientId: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    return axiosInstance
      .put(
        `${API_URL}/recipients/change-default/${recipientId}`,
        {},
        authorizationHeader,
      )
      .then((response) => response?.data as RecipientUpdateMeta);
  } catch (error) {
    console.error(error);

    return {
      acknowledged: false,
      matchedCount: 0,
      modifiedCount: 0,
      upsertedCount: 0,
      upsertedId: 0,
    };
  }
}

async function getMyRecipients(
  limit?: number,
  page?: number,
): Promise<RecipientsResponseModel> {
  try {
    const authorizationHeader = configAuthorizationHeader();

    const params = new URLSearchParams();

    if (limit) {
      params.append("limit", "" + limit);
    }
    params.append("page", "" + (page || 0));

    return axiosInstance
      .get(
        `${API_URL}/recipients/my${params.size ? `?${params.toString()}` : ""}`,
        authorizationHeader,
      )
      .then((response) => response?.data as RecipientsResponseModel);
  } catch (error) {
    console.error(error);

    return {
      currentPage: 0,
      recipients: [],
      pageSize: 0,
      totalItems: 0,
    };
  }
}

async function getRecipients(
  filter: object,
  limit?: number,
  page?: number,
): Promise<RecipientsResponseModel> {
  try {
    const authorizationHeader = configAuthorizationHeader();

    const params = new URLSearchParams();

    if (limit) {
      params.append("limit", "" + limit);
    }
    params.append("page", "" + (page || 0));

    return axiosInstance
      .post(
        `${API_URL}/recipients${params.size ? `?${params.toString()}` : ""}`,
        filter,
        authorizationHeader,
      )
      .then((response) => response?.data as RecipientsResponseModel);
  } catch (error) {
    console.error(error);

    return {
      currentPage: 0,
      recipients: [],
      pageSize: 0,
      totalItems: 0,
    };
  }
}

async function getRecipientById(recipientId: number, page?: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.get(
      `${API_URL}/recipients/${recipientId}?${page ? "page=" + page : ""}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function deleteRecipientById(recipientId: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.delete(
      `${API_URL}/recipients/${recipientId}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

export default {
  createRecipient,
  editRecipient,
  getMyRecipients,
  getRecipientById,
  getRecipients,
  deleteRecipientById,
  changeDefaultRecipient,
};

export interface RecipientUpdateMeta {
  acknowledged: boolean;
  matchedCount: number;
  modifiedCount: number;
  upsertedCount: number;
  upsertedId: number;
}
